export default __webpack_public_path__ + "static/media/Group 3180@2x.86b9924e.png";